import script from "./CreateAnswerBot.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAnswerBot.vue?vue&type=script&setup=true&lang=js"

import "./CreateAnswerBot.vue?vue&type=style&index=0&id=fc8860b0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8860b0"]])

export default __exports__